<template>
  <div class="modal-card" id="draggable" style="width: 500px;" >
    <header class="modal-card-head pop-header">
      <p class="modal-card-title tit">
        <span>{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
      </p>
    </header>
    <section class="modal-card-body pop-content">
      <el-form>
        <el-row>
          <el-form-item label="새 비밀번호">
            <el-input type="password" v-model="form.newPw"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="비밀번호 확인">
            <el-input type="password" v-model="form.verifyPw"></el-input>
          </el-form-item>
        </el-row>
        <br>
        <el-button type="primary" icon="el-icon-document-add" @click="changeButton">저장</el-button>
        <el-button type="info" icon="el-icon-close" @click="resetButton">취소</el-button>
      </el-form>
    </section>
  </div>
</template>
<script>
import mixin from '@/mixin';

export default {
  name: 'ChangePwdPop',
  components: {
  },
  mixins: [ mixin ],
  /* eslint-disable */
  props: {
    userId: 0
  },
  data() {
    return {
      title: '비밀번호 변경',
      form: {
        userId: '',
        currentPw: '',
        newPw: '',
        verifyPw: '',
      },
    }
  },
  mounted() {
    //pop slots modal move
    $(".animation-content").draggable({'cancel':'.modal-card-body'});

    this.form.userId = this.userId;
    
  },
  methods: {
    create(){

    },
    closeModal() {
      this.$parent.close();
    },
    changeButton(){
      if(this.changePreCheck()) this.change();
    },
    changePreCheck(){


      if(!this.form.newPw){
        this.$swal({ type: 'warning', text: '새 비밀번호 입력 바랍니다.' })
        //alert('Please Enter New Password !!')
        return false;
      }

      if(!this.form.verifyPw){
        this.$swal({ type: 'warning', text: '비밀번호 확인 입력 바랍니다.' })
        //alert('Please Enter Verify Password !!')
        return false;
      }

      if( this.form.newPw != this.form.verifyPw){
        this.$swal({ type: 'warning', text: '새 비밀번호 와 비밀번호 확인이 일치 하지 않습니다.' })
        //alert("New Password and Verify Password not the same !!");
        return false;
      }

      return true;
    },
    change(){
      let vm = this

      this.$swal({
        type: 'warning',
        text: `패스워드 변경 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {

        if (result.value) {
          this.$store.commit('loading')
          this.$http.post(`/api/common/admin/change/password`, JSON.parse(JSON.stringify(vm.form)))
              .then((response) => {
                this.$swal({type: 'success', text: '변경 되었습니다.'})
                this.closeModal()
              })
              .catch((e) => {
                this.$swal({type: 'error', text: e.response.data.message});
              }).finally(() => {
            this.$store.commit('finish');
          });
        }
      });
    } ,
    resetButton(){
      //초기화
      this.form.newPw = '';
      this.form.verifyPw = '';
    },
  },
};
</script>

<style>

.modal-card-head {background: #0065b3;}
.modal-card-title {color:white; font-size:1.2em;}
.modal-close {top: 80px;}

.modal-input {
  width: 100%;
}
</style>
